import { z } from 'zod';
import {
  goalSchema,
  type CreateGoalInput,
  type Goal,
  type GoalListQuery,
  type UpdateGoalInput,
} from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';

const listSchema = z.object({ items: z.array(goalSchema) });

export async function fetchGoals(query: Partial<GoalListQuery> = {}): Promise<Goal[]> {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value !== undefined && value !== '') params.set(key, String(value));
  }
  const search = params.toString();
  const result = await apiFetch<unknown>(`/goals${search ? `?${search}` : ''}`);
  return listSchema.parse(result).items;
}

export async function createGoal(input: CreateGoalInput): Promise<Goal> {
  return goalSchema.parse(await post<unknown>('/goals', input));
}

export async function updateGoal(goalId: string, input: UpdateGoalInput): Promise<Goal> {
  return goalSchema.parse(
    await apiFetch<unknown>(`/goals/${goalId}`, {
      method: 'PATCH',
      body: JSON.stringify(input),
    }),
  );
}

export async function deleteGoal(goalId: string): Promise<{ removed: boolean }> {
  return apiFetch<{ removed: boolean }>(`/goals/${goalId}`, { method: 'DELETE' });
}
